import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class AppDaoService implements Resetable {
  /**
   * Load the token Id of the mobile client
   */
  public abstract loadTokenId(): Promise<string>;

  /**
   * Save the token id of the mobile client
   */
  public abstract saveTokenId(tokenId: string): Promise<void>;

  /**
   * Load the last known build version of the mobile client
   */
  public abstract loadBuildVersion(): Promise<number | string>;

  /**
   * Save the current build version of the mobile client
   */
  public abstract saveBuildVersion(
    buildVersion: number | string
  ): Promise<void>;

  // Resetable
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
